import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { addFilter, removeFilter } from "../actions/filters";
import UiSlider from "./uiSlider";
import { Link } from "react-router-dom";
/**
* Just a wrapper under list items
*
*/
class FiltersValueses extends Component {

  static propTypes = {
    valuesData: PropTypes.object,
    filtersSelected: PropTypes.array,
    filterId: PropTypes.number,
    value: PropTypes.number,
    minMaxSelected: PropTypes.array,
    filterData: PropTypes.array,
    location: PropTypes.object,
    history: PropTypes.object
  };


  changeSelect = (url) => {
    this.props.history.replace(url);
  };


  buildLink = (filterId, valueId) => {
    if (this.props.location) {
      const filtersData = this.props.filterData.filter(() => true);



      const condition = `${filterId}-${valueId}`;
      const index = filtersData.indexOf(condition);
      if (index === -1) {
        filtersData.push(condition);
      } else {
        filtersData.splice(index, 1);
      }
      let search = this.props.location.search;
      let linkFilterQuery = '';
      if (filtersData.length > 0) {
        let linkFilterQuery = filtersData.join('+');
        if (this.props.location.search.includes('filter=')) {
          search = this.props.location.
            search.
            replace(/(?<=filter=)(.*?)(?=&l|&p|&s|$)/gm, linkFilterQuery);
          search = search.replace(/page=[0-9]+/gm, "page=1");

        } else {
          search = this.props.location.search.length > 0 ? `${search}&filter=${linkFilterQuery}` : `?filter=${linkFilterQuery}`;
        }
      } else {
        search = this.props.location.search.replace(/((&|\?)filter=)(.*?)(?=&l|&p|&s|$)/gm, '');
        search = search.replace(/((&|\&)page=)/gm, '?page=');
      }

      return `${this.props.location.pathname}${search}`.replace(/page=\d/, 'page=1');
    } else {
      return '';
    }
  }

  filterLink = (link, name, count, id, checked) => {
    if (count === 0){
    return   <div className="filter-no-active">
        <input className="uk-checkbox uk-margin-small-right" type="checkbox" disabled />
        <span className="uk-text-bold">{name}</span>
        <span className='uk-margin-small-left uk-text-muted'>(0) </span>
      </div>
    }
    return (
      <>
        <input className="uk-checkbox uk-margin-small-right"
          id={id}
          type="checkbox"
          checked={checked ? "checked" : ""}
          onChange={event => this.changeSelect(link)} />
        <Link to={link}>
          <span className="uk-text-bold">{name}</span>
          <span className='uk-margin-small-left uk-text-muted'>({count})</span>
        </Link>
      </>
    )


  }

  render() {
    return (<>

      {/* {console.log("this props valueData", this.props)} */}

      {
        this.props.valuesData.type === 2 ?
          <ul className="filter-list uk-list uk-padding-remove uk-accordion-content">
            {
              Object.keys(this.props.valuesData.values).map((itm, inx) => {
                const valueId = this.props.valuesData.values[itm].id;
                const link = this.buildLink(this.props.filterId, valueId);
                const checked = this.props.filtersSelected.find(elem => {
                  console.log("elem 98" , elem, valueId);
                  return elem === valueId
                });
                    
                return <li key={"value" + inx}>
                  {Object.keys(this.props.filtersByGoodsForCount).length > 0 &&
                    this.props.filtersByGoodsForCount[this.props.filterId] !== undefined
                    &&
                    this.props.filtersByGoodsForCount[this.props.filterId].values[valueId] !== undefined
                    ?
                    this.filterLink(link, this.props.valuesData.values[itm].value, this.props.filtersByGoodsForCount[this.props.filterId].values[this.props.valuesData.values[itm].id].count, this.props.valuesData.values[itm].id, checked)
                    :
                    Object.keys(this.props.filtersByGoods).length > 0 &&
                      this.props.filtersByGoods[this.props.filterId] !== undefined && this.props.filtersByGoods[this.props.filterId].values[valueId] !== undefined
                      ? this.filterLink(link, this.props.valuesData.values[itm].value, this.props.filtersByGoods[this.props.filterId].values[this.props.valuesData.values[itm].id].count, this.props.valuesData.values[itm].id, checked)
                      :
                      <div className="filter-no-active">
                        <input className="uk-checkbox uk-margin-small-right" type="checkbox" disabled />
                        <span className="uk-text-bold">{this.props.valuesData.values[itm].value}</span>
                        <span className='uk-margin-small-left uk-text-muted'>(0) </span>
                      </div>
                  }
                </li>
              }
              )
            }
          </ul>
          :
          <div>
            <UiSlider
              key={this.props.filterId + "range"}
              minValue={this.props.valuesData.values.min}
              maxValue={this.props.valuesData.values.max}
              maxValueLimit={this.props.valuesData.values.max + 20}
              filterId={this.props.filterId} />
          </div>
      }
    </>);
  }
}

const mapStateToProps = (store) => {
  /**
* Passing to props required props
*
* @param store
* @returns {{filtersSelected: getsListProducts.filtersSelected, minMaxSelected: getsListProducts.minMaxSelected}}
*/
  const { filtersSelected, minMaxSelected } = store.goods;

  return {
    filtersSelected: filtersSelected,
    minMaxSelected: minMaxSelected
  }
};

/**
* Trigger add, remove checked filters from global store
*
* @param dispatch
* @returns {{changeSelect: changeSelect}}
*/
const mapDispatchToProps = (dispatch) => {
  return {
    changeSelect: (e, value_id, filter_id) => {
      if (e.target.checked) {
        dispatch(addFilter(value_id, filter_id + "-" + value_id));
      } else {
        dispatch(removeFilter(value_id, filter_id + "-" + value_id));
      }
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersValueses)
